import React from 'react';
import DepartmentOverviewTopRow from '../portal/DepartmentOverviewTopRow';
import DepartmentWhatsNewCard from '../portal/DepartmentWhatsNewCard';
import DepartmentImplementationCard from '../portal/DepartmentImplementationCard';

const SALES_FALLBACK_SCHEDULE_URL = 'https://calendly.com/ken-zwz1/sales-strategy-call';

const SalesAllTab = () => {
  return (
    <div>
      {/* Community · Roadmap (with current task) · Goals */}
      <DepartmentOverviewTopRow category="sales" />

      {/* What's New (left) · Implementation Hours (right) */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <DepartmentWhatsNewCard department="sales" />
        <DepartmentImplementationCard
          department="sales"
          fallbackScheduleUrl={SALES_FALLBACK_SCHEDULE_URL}
        />
      </div>
    </div>
  );
};

export default SalesAllTab;
